import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormPreviewService {

  constructor(
    private _http: HttpClient
  ) { }

  getFormDetails(formId) {
    return this._http.get(environment.url + "/getFormDetails/" + formId);
  }

  submitFormDetails(formData, submit_help?) {
    let endPoint = ""
    if(submit_help == "true" || submit_help == true) {
      endPoint = `${environment.url}/submitForm?submit_help=true`
    } else {
      endPoint = `${environment.url}/submitForm`
    }
    return this._http.post(endPoint, formData);
  }
}
